import React from 'react';

function StarProjector() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_241_868)">
        <g filter="url(#filter0_d_241_868)">
          <path
            d="M60.6242 8.02202H23.0562C16.1682 8.02202 10.5322 13.686 10.5322 20.61V39.04L10.5442 39.052C10.5442 39.2 10.5322 39.344 10.5322 39.492C10.5322 56.872 24.5502 70.96 41.8402 70.96C41.9862 70.96 42.1322 70.95 42.2782 70.948L42.2902 70.96H60.6262C67.5142 70.96 73.1502 65.296 73.1502 58.372V20.608C73.1502 13.684 67.5142 8.02002 60.6262 8.02002L60.6242 8.02202Z"
            fill="#E0DDDA"
          />
          <path
            d="M44.122 76.022H40.4079C39.9319 76.022 39.5439 75.636 39.5439 75.158V70.582H44.984V75.158C44.984 75.634 44.598 76.022 44.12 76.022H44.122Z"
            fill="#F7F4F1"
          />
          <path
            d="M44.1221 76.822H40.4081C39.4901 76.822 38.7441 76.076 38.7441 75.158V70.582C38.7441 70.14 39.1021 69.782 39.5441 69.782H44.9841C45.4261 69.782 45.7841 70.14 45.7841 70.582V75.158C45.7841 76.076 45.0381 76.822 44.1201 76.822H44.1221ZM40.3461 71.382V75.158C40.3461 75.192 40.3741 75.222 40.4101 75.222H44.1241C44.1601 75.222 44.1881 75.194 44.1881 75.158V71.382H40.3481H40.3461Z"
            fill="#84827E"
          />
          <path
            d="M25.7402 72.0898L22.5242 70.2338C22.1122 69.9958 21.9702 69.4678 22.2082 69.0538L24.4962 65.0898L29.2082 67.8098L26.9202 71.7738C26.6822 72.1858 26.1542 72.3278 25.7402 72.0898V72.0898Z"
            fill="#F7F4F1"
          />
          <path
            d="M26.17 73.0079C25.882 73.0079 25.598 72.9319 25.34 72.7839L22.124 70.9279C21.74 70.7059 21.464 70.3479 21.348 69.9179C21.234 69.4879 21.292 69.0399 21.514 68.6559L23.802 64.6919C24.022 64.3099 24.512 64.1779 24.894 64.3999L29.606 67.1199C29.79 67.2259 29.924 67.3999 29.978 67.6059C30.032 67.8099 30.004 68.0299 29.898 68.2139L27.61 72.1779C27.388 72.5619 27.03 72.8379 26.6 72.9539C26.456 72.9919 26.312 73.0119 26.166 73.0119L26.17 73.0079ZM24.79 66.1839L22.902 69.4539C22.902 69.4539 22.888 69.4759 22.896 69.5019C22.902 69.5279 22.92 69.5379 22.926 69.5399L26.142 71.3959C26.142 71.3959 26.164 71.4099 26.19 71.4019C26.216 71.3959 26.226 71.3779 26.228 71.3719L28.116 68.1019L24.79 66.1819V66.1839Z"
            fill="#84827E"
          />
          <path
            d="M11.7888 59.496L9.93281 56.28C9.69481 55.868 9.83681 55.338 10.2488 55.1L14.2128 52.812L16.9328 57.524L12.9688 59.812C12.5568 60.05 12.0268 59.908 11.7888 59.496V59.496Z"
            fill="#F7F4F1"
          />
          <path
            d="M12.5385 60.7279C11.9625 60.7279 11.4025 60.4299 11.0945 59.8959L9.2385 56.6799C9.0165 56.2959 8.9565 55.8459 9.0725 55.4179C9.1865 54.9879 9.4625 54.6299 9.8485 54.4079L13.8125 52.1199C13.9965 52.0139 14.2145 51.9839 14.4205 52.0399C14.6245 52.0939 14.8005 52.2279 14.9065 52.4119L17.6265 57.1239C17.8465 57.5059 17.7165 57.9959 17.3345 58.2159L13.3705 60.5039C13.1085 60.6539 12.8245 60.7259 12.5425 60.7259L12.5385 60.7279ZM12.4805 59.0959C12.4985 59.1259 12.5365 59.1359 12.5665 59.1199L15.8365 57.2319L13.9165 53.9059L10.6465 55.7939C10.6465 55.7939 10.6245 55.8079 10.6165 55.8319C10.6105 55.8579 10.6205 55.8739 10.6225 55.8799L12.4785 59.0959H12.4805Z"
            fill="#84827E"
          />
          <path
            d="M6 41.6119V37.8979C6 37.4219 6.386 37.0339 6.864 37.0339H11.44V42.4739H6.864C6.388 42.4739 6 42.0879 6 41.6099V41.6119Z"
            fill="#F7F4F1"
          />
          <path
            d="M11.4402 43.2759H6.8642C5.9462 43.2759 5.2002 42.5299 5.2002 41.6119V37.8979C5.2002 36.9799 5.9462 36.2339 6.8642 36.2339H11.4402C11.8822 36.2339 12.2402 36.5919 12.2402 37.0339V42.4739C12.2402 42.9159 11.8822 43.2739 11.4402 43.2739V43.2759ZM6.8642 37.8359C6.8302 37.8359 6.8002 37.8639 6.8002 37.8999V41.6139C6.8002 41.6479 6.8282 41.6779 6.8642 41.6779H10.6402V37.8379H6.8642V37.8359Z"
            fill="#84827E"
          />
          <path
            d="M42.2662 71.488C59.7924 71.488 74.0002 57.2802 74.0002 39.754C74.0002 22.2278 59.7924 8.02002 42.2662 8.02002C24.74 8.02002 10.5322 22.2278 10.5322 39.754C10.5322 57.2802 24.74 71.488 42.2662 71.488Z"
            fill="white"
          />
          <path
            d="M35.024 8.02198C33.948 5.64198 31.564 3.97998 28.782 3.97998C26 3.97998 23.618 5.64198 22.54 8.02198H35.024Z"
            fill="url(#paint0_linear_241_868)"
          />
          <path
            d="M74.8004 39.754C74.8004 37.206 74.5044 34.726 73.9484 32.344V20.608C73.9484 13.226 67.9724 7.21998 60.6244 7.21998H35.5184C34.1904 4.74798 31.6004 3.17798 28.7824 3.17798C25.9644 3.17798 23.3464 4.76798 22.0244 7.26398C15.1584 7.79598 9.73242 13.574 9.73242 20.608V39.038C9.73242 39.072 9.73642 39.106 9.74042 39.14C9.74042 39.156 9.74042 39.17 9.74042 39.186V39.214C9.73642 39.306 9.73242 39.396 9.73242 39.488C9.73242 39.532 9.73242 39.576 9.73242 39.622C9.73242 39.666 9.73242 39.71 9.73242 39.754C9.73242 57.694 24.3264 72.288 42.2664 72.288C44.2684 72.288 46.2304 72.104 48.1344 71.756H60.6264C67.9724 71.756 73.9504 65.75 73.9504 58.368V47.162C74.5064 44.78 74.8024 42.3 74.8024 39.752L74.8004 39.754ZM42.4124 70.156C42.3644 70.148 42.3164 70.144 42.2684 70.144C42.1984 70.144 42.1284 70.148 42.0584 70.15C41.9864 70.152 41.9144 70.156 41.8404 70.156C25.0624 70.156 11.4064 56.47 11.3344 39.62C11.3344 39.482 11.3364 39.346 11.3404 39.208C11.3404 39.158 11.3444 39.108 11.3444 39.056C11.3444 39.048 11.3444 39.04 11.3444 39.032C11.7284 22.306 25.4524 8.81798 42.2684 8.81798C56.8404 8.81798 69.0904 18.948 72.3504 32.534V46.968C69.5264 58.736 59.9624 67.908 47.9824 70.154H42.4124V70.156ZM60.6244 8.82198C67.0884 8.82198 72.3484 14.11 72.3484 20.61V27.37C68.7324 18.622 61.4084 11.782 52.3444 8.82198H60.6244ZM28.7824 4.77798C30.7084 4.77798 32.4984 5.70598 33.6284 7.21998H23.9364C25.0664 5.70598 26.8584 4.77798 28.7824 4.77798V4.77798ZM11.3324 20.608C11.3324 14.108 16.5904 8.81998 23.0564 8.81998H32.1884C22.3424 12.036 14.5484 19.83 11.3324 29.676V20.608V20.608ZM72.3484 58.37C72.3484 64.87 67.0904 70.158 60.6244 70.158H53.8444C62.2124 66.96 68.9344 60.402 72.3484 52.142V58.372V58.37Z"
            fill="#84827E"
          />
          <path
            d="M42.266 59.484C31.388 59.484 22.54 50.636 22.54 39.758C22.54 28.88 31.388 20.032 42.266 20.032C53.144 20.032 61.992 28.88 61.992 39.758C61.992 50.636 53.144 59.484 42.266 59.484V59.484ZM42.266 23.462C33.28 23.462 25.97 30.772 25.97 39.758C25.97 48.744 33.28 56.054 42.266 56.054C51.252 56.054 58.562 48.744 58.562 39.758C58.562 30.772 51.252 23.462 42.266 23.462V23.462Z"
            fill="url(#paint1_linear_241_868)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_241_868"
          x="3.8002"
          y="1.77798"
          width="75.6025"
          height="79.644"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_868"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_868"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_868"
          x1="24.2959"
          y1="4.34151"
          x2="25.7441"
          y2="9.47194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_868"
          x1="28.089"
          y1="23.5607"
          x2="54.8692"
          y2="54.2792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <clipPath id="clip0_241_868">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default StarProjector;
